import React, { useCallback, useState } from 'react'
import styled from '@emotion/styled'
import { Text, spacing, Card, Button } from '@retailer-platform/shared-components'
import { css } from '@emotion/react'
import { SectionHeader } from '../../shared-styled-components/SharedStyledComponents'
import { useDomainMessages } from '../../../utils/domain/intl'
import { RegexCardList } from './regex-components/RegexCardList'
import { RegexCard } from './regex-components/RegexCard'
import { type FormProps } from './StepAttributeForm'

const Container = styled.div({
  padding: spacing.X16,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.X16,
  alignItems: 'center',
})

export interface Rule {
  match: string
  replace: string
  isDefault: boolean
}

export interface FieldDefinition {
  inputField: string
  outputField: string
}

export interface Mutation extends FieldDefinition {
  rules: Rule[]
}

const RegexForm: React.FC<FormProps> = ({ attributes, mode, onChange, version }) => {
  const i18n = useDomainMessages({
    mutations: 'catalogAdminDomain.attributeManagement.regex.form.mutation.title',
    mutationsDescription: 'catalogAdminDomain.attributeManagement.regex.form.mutation.description',
    addMutation: 'catalogAdminDomain.attributeManagement.regex.form.mutation.add',
  })
  const [addingNewMutation, setAddingNewMutation] = useState(false)

  const onMutationChange = useCallback(
    (mutations: Mutation[]) => {
      onChange({ ...attributes, mutations })
    },
    [attributes, onChange]
  )
  return (
    <>
      <SectionHeader>{i18n.mutations}</SectionHeader>
      <Text size="small" styles={css({ padding: spacing.X16 })}>
        {i18n.mutationsDescription}
        <a href="https://regex101.com/" target="_blank" rel="noopener noreferrer">
          here
        </a>
        .
      </Text>
      <Container>
        <RegexCardList
          mutations={attributes.mutations}
          readOnly={mode !== 'edit'}
          onChange={onMutationChange}
        />
        {addingNewMutation ? (
          <RegexCard
            readOnly={mode !== 'edit'}
            onDelete={() => setAddingNewMutation(false)}
            onChange={mutation => {
              onChange({ ...attributes, mutations: [...attributes.mutations, mutation] })
              setAddingNewMutation(false)
            }}
            mutation={{ inputField: '', outputField: '', rules: [] }}
            isNew={true}
            bannedCombinations={attributes.mutations.map((m: Mutation) => ({
              inputField: m.inputField,
              outputField: m.outputField,
            }))}
          />
        ) : (
          mode === 'edit' && (
            <Button variant="primary" onClick={() => setAddingNewMutation(true)}>
              {i18n.addMutation}
            </Button>
          )
        )}
      </Container>
    </>
  )
}

export default RegexForm
